import { render, staticRenderFns } from "./userToken.vue?vue&type=template&id=0ebb0810&"
import script from "./userToken.vue?vue&type=script&lang=js&"
export * from "./userToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports